//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { IUserSession, UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { default as SERVICES_MODULE_NAME } from './../../services/services.module'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { ReportController } from './reports.controller'
import { ReportDetailsDirective } from './details/reports-details.directive'
import { ReportCreateEditDirective } from './create-edit/reports-create-edit.directive'

import { ReportHelper } from './reports.helper'
import { USER_SESSION_SERVICE_NAME } from '../../services/user-session'
import { GRID_CONTEXT_MENU_SERVICE_NAME, GridContextMenuService } from '../../services/grid'
import { COMPONENT_NAME as STORED_PROCEDURE_REPORT_POPUP_FORM_NAME, StoredProcedureReportPopupFormComponent } from './custom/stored-procedure-report/popup/stored-procedure-report-popup-form.component'


//#region Asset Imports

import * as TEMPLATE from './reports.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'ReportController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'reportCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'reportDetails'
const MENU_INDEX = 11
const MODULE_NAME: string = 'simax.reports'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'REPORT_NAME'
const STATE_NAME: string = 'reports'
const STATE_URL: string = '/reports'

// Consts End


// Setup 

var module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME]);

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    '$window',
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: any,
        $window: Window,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSession: IUserSession,
        systemService: SystemService
    ) => new ReportController(
        $scope,
        $window,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        gridContextMenuService,
        userSession,
        systemService,
        ReportHelper.REFERENCE_TYPE,
        ReportHelper.SIMAX_MODULE_NAME
    )]);

module.directive(DETAILS_DIRECTIVE_NAME, [() => new ReportDetailsDirective()]);
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new ReportCreateEditDirective()]);

// #region Component

module.component(STORED_PROCEDURE_REPORT_POPUP_FORM_NAME, new StoredProcedureReportPopupFormComponent())

// #endregion

/**
 * The [compile] directive.
 * 
 */
module.directive('compile', ['$compile', $compile => (scope, element, attrs) => {
    scope.$watch(
        scope => scope.$eval(attrs.compile),
        value => {
            element.html(value);
            $compile(element.contents())(scope);
        }
    );
}]);

/**
 * The [valid-current-page] directive.
 *
 * This directive validates current page input value. 
 */
module.directive('validCurrentPage', () => ({
    require: '?ngModel',
    link: (scope: any, element, attrs, ngModelCtrl: any) => {
        if (!ngModelCtrl) {
            return;
        }

        ngModelCtrl.$parsers.push(val => {
            var clean = val.replace(/[^0-9]+/g, '');
            if (val !== clean) {
                ngModelCtrl.$setViewValue(clean);
                ngModelCtrl.$render();
            }
            return clean;
        });

        element.on('keypress', event => {
            if (event.keyCode === 32) {
                event.preventDefault();
            }
            if (event.keyCode === 13) {
                scope.model.confirmPage();
                element.blur();
            }
        });
    }
}));

/**
 *  The config.
 */
module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Report_IdReport',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.REPORTS_LIST)
                && !loggedOperator.hasPermission(Activity.REPORT_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ReportModule)) {
                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.REPORTS),
                    'reports',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                );

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}]);

export default MODULE_NAME

// Setup End